// @flow

import LngLatBounds from "../geo/lng_lat_bounds";
import MercatorCoordinate, {mercatorXfromLng, mercatorYfromLat} from "../geo/mercator_coordinate";

import type {CanonicalTileID} from "./tile_id";

class TileBounds {
    bounds: LngLatBounds;
    minzoom: number;
    maxzoom: number;

    constructor(
        bounds: [number, number, number, number],
        minzoom: ?number,
        maxzoom: ?number
    ) {
        this.bounds = LngLatBounds.convert(this.validateBounds(bounds));
        this.minzoom = minzoom || 0;
        this.maxzoom = maxzoom || 24;
    }

    validateBounds(bounds: [number, number, number, number]) {
        // make sure the bounds property contains valid longitude and latitudes
        if (!Array.isArray(bounds) || bounds.length !== 4)
            return [-180, -90, 180, 90];
        return [
            Math.max(-180, bounds[0]),
            Math.max(-90, bounds[1]),
            Math.min(180, bounds[2]),
            Math.min(90, bounds[3]),
        ];
    }
    /*
     * fix(25725): 无法正确显示mapgis发布的arcgis矢量瓦片服务
     * 修改说明：兼容TileBounds判断瓦片是否存在的逻辑
     * 版权所有: 武汉中地数码科技有限公司
     * 修改人：赵凯 2025年5月9日
     */
    contains(tileID: CanonicalTileID, crs) {
        let worldSize = Math.pow(2, tileID.z);
        let level;
        if (crs) {
            // 兼容非二次幂的情况，修正瓦片层级对应的worldSize大小
            worldSize = worldSize / crs.getScaleFactorByTileZoom(tileID.z);
            const p1 = MercatorCoordinate.fromLngLat(
                this.bounds.getNorthEast(),
                0,
                crs
            );
            const p2 = MercatorCoordinate.fromLngLat(
                this.bounds.getSouthWest(),
                0,
                crs
            );
            level = {
                minX: Math.floor(p2.x * worldSize),
                minY: Math.floor(p1.y * worldSize),
                maxX: Math.ceil(p1.x * worldSize),
                maxY: Math.ceil(p2.y * worldSize),
            };
        } else {
            level = {
                minX: Math.floor(
                    mercatorXfromLng(this.bounds.getWest()) * worldSize
                ),
                minY: Math.floor(
                    mercatorYfromLat(this.bounds.getNorth()) * worldSize
                ),
                maxX: Math.ceil(
                    mercatorXfromLng(this.bounds.getEast()) * worldSize
                ),
                maxY: Math.ceil(
                    mercatorYfromLat(this.bounds.getSouth()) * worldSize
                ),
            };
        }
        const hit =
            tileID.x >= level.minX &&
            tileID.x < level.maxX &&
            tileID.y >= level.minY &&
            tileID.y < level.maxY;
        return hit;
    }
}

export default TileBounds;
